<template>
  <div id="mqttws" class="mqttws">
    <!-- <input type="text" id="msg" v-model="msg"/> -->
    <!-- <input type="button" value="Send" @click="send(msg)" />
    <input type="button" value="Start" @click="start"/>
    <input type="button" value="Stop" @click="stop"/> -->
  </div>
</template>

<script>
  import {Uint8ArrayToString,strToHexCharCode} from '../../../../static/js/utils/util.js'
  import { storage } from '../../../../static/turnoverCabinet/js/utility'
  import * as config from '../../../../static/js/config.js'
  
  export default {
    name: 'BCmqttws',
    props:{
      // 订阅主题
      topic:{
       type: String,
       default: ''
      },
      // 数据是否是16进制
      msgIsHex:{
        type: Boolean,
        default: false
      },
      // 发送信息
      msg:{
        type: String
      },
      // 组件加载不自动连接
      notAutoConnect: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isConnect: false, //是否连接

        hostname: config.serverPort,//地址
        port: config.mqttInfo.port,//端口号
        clientId: config.mqttInfo.clientId,//clientId（不能重复）
        userName: config.mqttInfo.userName,
        password: config.mqttInfo.password,

        timeout: 5,
        keepAlive: 50, 
        cleanSession: false,
        ssl: false,
        client:{},
        options: {},
      }
    },
    created : function() {
      if (!this.notAutoConnect) {
        this.onConnection();
        console.log('clientId', this.clientId)
        console.log('server_address', config.serverPort, this.topic)
      }
    },
    mounted : function () {
    },
    methods: {
      //开始连接
      onConnection(successFunc) {
        var that = this;
        this.client = new Paho.MQTT.Client(this.hostname, this.port, this.clientId);
        var _client= this.client;
        var opt = this.options =
          {
            invocationContext: {
              host: that.hostname,
              port: that.port,
              path: _client.path,
              clientId: that.clientId
            },
            timeout: that.timeout,
            keepAliveInterval: that.keepAlive,
            cleanSession: that.cleanSession,
            useSSL: that.ssl,
            userName: that.userName,
            password: that.password,
            onSuccess: function(res) {
              that.isConnect = true
              console.log("连接成功",res);
              console.log('主题', that.topic)
              _client.subscribe(that.topic);//订阅主题
              if (typeof(successFunc) == 'function') {
                successFunc()
              }
            },
            onFailure: function (e) {
              console.log('链接失败：',e);
              that.onConnection()
            }
          };
        this.client.connect(opt);//连接服务器并注册连接成功处理事件
        this.client.onConnectionLost = this.onConnectionLost;//注册连接断开处理事件
        this.client.onMessageArrived = this.onMessageArrived;//注册消息接收处理事件
      },
      //连接已断开
      onConnectionLost(responseObject) {
        this.isConnect = false
        console.log('连接已断开', responseObject)
        if (responseObject.errorCode !== 0) {
          console.log("连接已断开",responseObject.errorMessage)
        }
      },
      //收到消息
      onMessageArrived(message) {
        console.log('收到消息', message)
        // console.log("收到消息:",message.payloadString);
        // this.$emit('getMessage', JSON.parse(message.payloadString))
        let msg
        if (this.msgIsHex) {
          msg = strToHexCharCode(Uint8ArrayToString(message.payloadBytes))
          // conLog("收到消息:",msg);
        } else {
          msg = JSON.parse(message.payloadString)
        }
        console.log('msg', msg)
        this.$emit('getMessage',msg)
      },
      //订阅主题
      onConnect(topic) {
        console.log("onConnected");
        this.client.subscribe(topic);//订阅主题
      },
      //发送消息
      send1(msg) {
        var s = msg;
        if(s){
          // s = "{time:"+new Date().Format("yyyy-MM-dd hh:mm:ss")+", content:"+(s)+", from: web console}";
          var message = new Paho.MQTT.Message(s);
          message.destinationName = this.topic;
          console.log('send',message)
          this.client.send(message);
          // this.msg = '';//如果为空，第二次就不能发送空消息了
        }
      },
      //发送消息
      send(topic,msg){
        console.log('send',topic,msg)
        var s = msg;
        if(s){
          var strArr = [];
          var n = 2;
          for (var i = 0, l = s.length; i < l/n; i++) {
            var a = s.slice(n*i, n*(i+1));
            a = parseInt(a, 16);
            // a = hex_to_bin(a);//把数组的每个元素转成10进制数据
            strArr.push(a);
          }
          //把10进制数据放进uint8array对象传过去
          var uint8Arr = new Uint8Array(strArr);
          var message = new Paho.MQTT.Message(uint8Arr);
          message.destinationName = topic;
          // message.qos = 0
          // message.retain = 0
          this.client.send(message);
          msg = '';//如果为空，第二次就不能发送空消息了
        }
      },
      start() {
        window.tester = window.setInterval(function(){
          if(this.client.isConnected){
            var s = this.msg;
            var message = new Paho.MQTT.Message(s);
            message.destinationName = this.topic;
            this.client.send(message);
          }
        }.bind(this), 1000);
      },
      stop() {
        window.clearInterval(window.tester);
        // this.client.disconnect();
        // console.log('已断开')
      },
      //断开mqtt
      disconnect() {
        console.log('已断开连接')
        this.client.disconnect();
      }
    },
    destroyed() {
      console.log('destroyed', '')
      if (this.isConnect) {
        this.client.disconnect();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Bookcase/Common/Mqttws.vue